// extracted by mini-css-extract-plugin
export default {"title":"WebsiteContent_title__OjhOy"};